import React from 'react';

export default function (props) {
    return (
        <div style={{ ...props.style }}>
            <svg
                width={props.size}
                height={props.size}
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill={props.color}
                    style={{ background: '#FFF' }}
                    d="M18.1,0.1H1.9c-1,0-1.8,0.8-1.8,1.8v16.2c0,1,0.8,1.8,1.8,1.8h16.2c1,0,1.8-0.8,1.8-1.8V1.9
	C19.9,0.9,19.1,0.1,18.1,0.1z M6.2,17.2c0,0.3-0.2,0.5-0.5,0.5H3.5c-0.3,0-0.5-0.2-0.5-0.5V7.9c0-0.3,0.2-0.5,0.5-0.5h2.2
	c0.3,0,0.5,0.2,0.5,0.5V17.2z M4.6,6.5c-1.2,0-2.1-0.9-2.1-2.1s0.9-2.1,2.1-2.1s2.1,0.9,2.1,2.1S5.8,6.5,4.6,6.5z M17.8,17.2
	c0,0.3-0.2,0.5-0.5,0.5H15c-0.3,0-0.5-0.2-0.5-0.5v-4.4c0-0.7,0.2-2.9-1.7-2.9c-1.5,0-1.8,1.5-1.8,2.2v5c0,0.3-0.2,0.5-0.5,0.5H8.2
	c-0.3,0-0.5-0.2-0.5-0.5V7.9c0-0.3,0.2-0.5,0.5-0.5h2.3c0.3,0,0.5,0.2,0.5,0.5v0.8c0.5-0.8,1.4-1.4,3.1-1.4c3.8,0,3.8,3.6,3.8,5.5
	L17.8,17.2L17.8,17.2z"/>
            </svg>
        </div>
    );
}
